<ng-container *ngIf="(blocks | async) as blocks">
  <app-tiles-grid class="grid" [blocks]="blocks | blocksSorting"></app-tiles-grid>
</ng-container>
